import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'
import { Transaction } from 'services'

export enum AnalyticsArea {
  Overview = 'Overview',
  Portfolio = 'Portfolio',
  Staking = 'Staking',
  Widget = 'Widget',
  IndexDetails = 'Index details',
  NotificationArea = 'Notification area',
  WalletManagement = 'Wallet management',
  NavigationBar = 'Navigation bar',
  About = 'About',
  Privacy = 'Privacy',
  Terms = 'Terms',
  Footer = 'Footer',
  FAQ = 'FAQ',
}

export enum UserAction {
  Click = 'Click',
  View = 'View',
  UserInput = 'Submit',
  Navigation = 'Navigation',
}

type AnalyticsEvent = (label: string, external?: boolean) => void
type NavigationEvent = (label: string, external?: boolean) => void
type TransactionProps = (transaction: Transaction) => void

interface AnalyticsTracker {
  clickEvent: AnalyticsEvent
  transactionEvent: TransactionProps
  navigationEvent: NavigationEvent
}

export const useAnalyticsEventTracker = (
  category: AnalyticsArea = AnalyticsArea.Overview,
): AnalyticsTracker => {
  const history = useNavigate()
  const eventTracker = (action: UserAction, label: string) => {
    ReactGA.event({ category, action, label })
  }

  const handleClickEvent = (label: string) => {
    // pass to GA
    eventTracker(UserAction.Click, label)
  }

  const handleTransactionEvent = (transaction: Transaction) => {
    // pass to GA
    if (transaction.action.indexDetails) {
      eventTracker(
        UserAction.UserInput,
        `${transaction.action.action} ${transaction.action.indexDetails.value} ${transaction.action.indexDetails.assetName} for account: ${transaction.account} `,
      )
    } else {
      eventTracker(
        UserAction.UserInput,
        `${transaction.action.action} transaction on account: ${transaction.account} `,
      )
    }
  }

  const handleNavigationEvent = (toPath: string, external?: boolean) => {
    // pass to GA
    eventTracker(UserAction.Navigation, `to ${toPath} from ${window.location.pathname}`)

    if (external) {
      window.open(toPath, '_blank', 'noreferrer')
    } else {
      history(toPath)
    }
  }

  return {
    clickEvent: handleClickEvent,
    transactionEvent: handleTransactionEvent,
    navigationEvent: handleNavigationEvent,
  }
}
